import { ThemeColor, ThemeMode } from "@/types/ApiResponses/UserPreferences";

interface AppConfig {
  authenticatedPath: string;
  unauthenticatedEntry: string;
  defaultThemeMode: ThemeMode;
  defaultThemeColor: ThemeColor;
  showQuickDeposit: boolean;
}

export const appConfig: AppConfig = {
  authenticatedPath: "/sportsbook",
  unauthenticatedEntry: "/sign-in",
  defaultThemeMode: ThemeMode.Light,
  defaultThemeColor: ThemeColor.Green,
  showQuickDeposit: true,
};
